export default __webpack_public_path__ + "static/media/audio_10_caballo.e737e9b5.mp3";